import { FC } from 'react';
import { useIntl } from 'react-intl';

import { ReactComponent as IconForward } from '../../../../../assets/images/forward-breadcrumbs.svg';
import { isProd, isStage } from '../../../../../config';
import './breadcrumbs.scss';

export interface BreadcrumbsProps {
    pageName?: string;
}

const Breadcrumbs: FC<BreadcrumbsProps> = ({ pageName }) => {
    const intl = useIntl();

    const getLinks = () => {
        if (isProd) {
            return {
                home: intl.formatMessage({ id: 'links.boxBookingProdLink', defaultMessage: 'https://apgsga.ch/de/' }),
                advertising: intl.formatMessage({
                    id: 'links.bookOutdoorProdLink',
                    defaultMessage: 'https://apgsga.ch/de/produkte-und-preise/',
                }),
            };
        }

        if (isStage) {
            return {
                home: intl.formatMessage({
                    id: 'links.boxBookingStageLink',
                    defaultMessage: 'https://apg-website-2021-private-cloud-stage.apg.divio.cloud/de/',
                }),
                advertising: intl.formatMessage({
                    id: 'links.bookOutdoorStageLink',
                    defaultMessage: 'https://apg-website-2021-private-cloud-stage.apg.divio.cloud/de/produkte-und-preise/',
                }),
            };
        }

        return {
            home: intl.formatMessage({
                id: 'links.boxBookingDevLink',
                defaultMessage: 'https://apg-website-2021-private-cloud-stage.apg.divio.cloud/de/',
            }),
            advertising: intl.formatMessage({
                id: 'links.bookOutdoorDevLink',
                defaultMessage: 'https://apg-website-2021-private-cloud-stage.apg.divio.cloud/de/produkte-und-preise/',
            }),
        };
    };

    const { home, advertising } = getLinks();

    return (
        <div className={'breadcrumbs__wrapper'}>
            <div className={'breadcrumbs__container'}>
                <a href={home}>{intl.formatMessage({ id: 'general.startPage', defaultMessage: 'Home' })}</a>

                <IconForward className={'breadcrumbs__icon-forward'} />

                <a href={advertising}>
                    {intl.formatMessage({
                        id: 'general.bookOutdoorAdvertisingPage',
                        defaultMessage: 'Produkte und Preise',
                    })}
                </a>

                {pageName && (
                    <>
                        <IconForward className={'breadcrumbs__icon-forward'} />
                        {pageName}
                    </>
                )}
            </div>
        </div>
    );
};

export default Breadcrumbs;
